import React from 'react';
import { VoiceRecorder } from '../UI/VoiceRecorder';

interface PantryVoiceRecorderProps {
  onRecordingComplete: (audio: Blob) => void;
  onRecordingCleared: () => void;
  maxDuration?: number;
  disabled?: boolean;
}

export const PantryVoiceRecorder: React.FC<PantryVoiceRecorderProps> = (props) => {
  const maxMinutes = Math.floor((props.maxDuration || 300) / 60);
  return (
    <VoiceRecorder
      {...props}
      idleHint={`Describe what's in your pantry, fridge, or kitchen (max ${maxMinutes} minutes).`}
    />
  );
};
